<template>
  <ElConfigProvider :z-index="zIndex" :locale="n_locale">
    <router-view />
  </ElConfigProvider>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from "vue";
import { ElConfigProvider } from "element-plus";
import cn from "element-plus/es/locale/lang/zh-cn";
import en from "element-plus/es/locale/lang/en";
import hk from "element-plus/es/locale/lang/zh-tw";
import { debounce } from "lodash";
import { useI18n } from "vue-i18n";

const lanMaps: Record<string, any> = {
  en: en,
  cn: cn,
  hk: hk,
};

export default defineComponent({
  components: {
    ElConfigProvider,
  },
  setup() {
    onMounted(() => {
      document.body.style.setProperty("--el-color-primary", "#095540d4");
      document.body.style.setProperty("--el-color-primary-dark-2", "#074433e3");
      document.body.style.setProperty("--el-color-primary-light-3", "#53887A");
      const _ResizeObserver = window.ResizeObserver;
      window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
        constructor(callback: any) {
          callback = debounce(callback, 16);
          super(callback);
        }
      };
    });
    const { locale } = useI18n({ useScope: "global" });
    const n_locale = computed(() => {
      return lanMaps[locale.value];
    });
    return {
      zIndex: 3000,
      n_locale,
    };
  },
});
</script>
<style lang="scss">
#app {
  height: 100%;
  width: 100%;
}
</style>
